module.exports = __webpack_public_path__ + "img/kajalshanto.e4183316.jpg";